module.exports = __webpack_public_path__ + "static/cheeksoft_europe-b87e36a4d5ff1d086df81613f67c57a5.png";